import React, { useState } from "react";
import usePlatformPipeline from "./hooks/usePlatformPipeline";
import PlatformCrmFilterBar from "./components/filters/PlatformCrmFilterBar";
import PlatformPipelineBoard from "./components/pipeline/PlatformPipelineBoard";
import PlatformLeadSidebar from "./components/pipeline/PlatformLeadSidebar";
import PlatformActionQueue from "./components/pipeline/PlatformActionQueue";
import PlatformStatCard from "../components/PlatformStatCard";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import NeoCard from "../../../components/Common/NeoCard";
import { Spinner, Alert, Row, Col } from "reactstrap";
import "./PlatformCrm.css";

const PlatformCrm = () => {
    const {
        columns,
        consultants,
        showArchived,
        archivedCount,
        toggleArchive,
        kpis,
        actionQueue,
        needsActionOnly,
        toggleNeedsAction,
        filters,
        loading,
        error,
        applyFilters,
        handleDragEnd,
        refetch
    } = usePlatformPipeline();

    // Estado do Lead selecionado para exibição no sidebar
    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleCardClick = (lead) => {
        setSelectedLeadId(lead.id);
        setSidebarOpen(true);
    };

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div className="pb-5">
            {/* Header */}
            <div className="mb-4">
                <Breadcrumb title="CRM de Leads B2B" />
            </div>

            {/* KPIs do Funil */}
            <Row className="g-3 mb-4">
                <Col xl={2} lg={4} md={4} sm={6}>
                    <PlatformStatCard icon="ph-light ph-funnel" label="Leads Ativos" value={loading ? "..." : String(kpis.activeCount)} color="primary" />
                </Col>
                <Col xl={2} lg={4} md={4} sm={6}>
                    <PlatformStatCard
                        icon="ph-light ph-warning-circle"
                        label="Sem Contato 3d+"
                        value={loading ? "..." : String(kpis.needsActionCount)}
                        color="danger"
                        onClick={toggleNeedsAction}
                        active={needsActionOnly}
                    />
                </Col>
                <Col xl={2} lg={4} md={4} sm={6}>
                    <PlatformStatCard icon="ph-light ph-presentation-chart" label="Demos Agendadas" value={loading ? "..." : String(kpis.demosScheduled)} color="purple" />
                </Col>
                <Col xl={2} lg={4} md={4} sm={6}>
                    <PlatformStatCard icon="ph-light ph-sparkle" label="Trials Ativos" value={loading ? "..." : String(kpis.trialsActive)} color="info" />
                </Col>
                <Col xl={2} lg={4} md={4} sm={6}>
                    <PlatformStatCard icon="ph-light ph-trophy" label="Ganhos no Mês" value={loading ? "..." : String(kpis.wonMonth)} color="success" />
                </Col>
                <Col xl={2} lg={4} md={4} sm={6}>
                    <PlatformStatCard icon="ph-light ph-percent" label="Conversão do Funil" value={loading ? "..." : `${kpis.conversionRate}%`} color="warning" />
                </Col>
            </Row>

            {/* Fila do Dia — follow-ups priorizados */}
            {!loading && (
                <PlatformActionQueue leads={actionQueue} onOpenLead={handleCardClick} />
            )}

            <NeoCard
                title="Funil de Vendas SaaS"
                subtitle="Gerenciamento de Leads B2B e conversão de novos clientes NeoApp."
                headerIcon="mdi-funnel"
                thinBorder={true}
                bodyClassName="p-3"
            >
                {/* Filtros */}
                <PlatformCrmFilterBar 
                    filters={filters}
                    consultants={consultants}
                    onChange={applyFilters}
                />

                {/* Alerta de erro se houver */}
                {error && (
                    <Alert color="danger" className="mb-4">
                        {error}
                    </Alert>
                )}

                {/* Board / Kanban */}
                {loading && Object.keys(columns).every(k => columns[k].length === 0) ? (
                    <div className="d-flex align-items-center justify-content-center py-5">
                        <Spinner color="primary" />
                    </div>
                ) : (
                    <PlatformPipelineBoard
                        columns={columns}
                        onDragEnd={handleDragEnd}
                        onCardClick={handleCardClick}
                        showArchived={showArchived}
                        onToggleArchive={toggleArchive}
                        archivedCount={archivedCount}
                    />
                )}
            </NeoCard>

            {/* Sidebar lateral de detalhes */}
            {selectedLeadId && (
                <PlatformLeadSidebar 
                    isOpen={sidebarOpen}
                    toggle={toggleSidebar}
                    leadId={selectedLeadId}
                    consultants={consultants}
                    onActionComplete={refetch}
                />
            )}
        </div>
    );
};

export default PlatformCrm;
